/** PoD portal ABIs vendored from `@coti-io/coti-wallet-plugin` (no longer on the 0.4.0 barrel). */

export const PRIVACY_PORTAL_ABI = [
  "function underlyingToken() view returns (address)",
  "function pToken() view returns (address)",
  "function decimals() view returns (uint8)",
  "function withdrawals(bytes32) view returns (address,address,uint256,uint256,uint256,bytes32,bytes32,uint8)",
  "function deposit(address recipient,uint256 amount,uint256 portalFee,uint256 mintCallbackFee) payable returns (bytes32)",
  "function depositNative(address recipient,uint256 amount,uint256 portalFee,uint256 mintCallbackFee) payable returns (bytes32)",
  "function nativeWrappedUnderlying() view returns (bool)",
  "function estimateDepositFees(uint256 amount) view returns (uint256 portalFee,bool usedDynamicPricing,uint256 mintTotalFee,uint256 mintCallbackFee)",
  "function estimateWithdrawFees(uint256 amount) view returns (uint256 portalFee,bool usedDynamicPricing,uint256 transferTotalFee,uint256 transferCallbackFee)",
  "function requestWithdrawWithPermit(address recipient,uint256 amount,uint256 portalFee,uint256 transferFee,uint256 transferCallbackFee,uint256 permitDeadline,uint8 v,bytes32 r,bytes32 s) payable returns (bytes32,bytes32)",
  "event DepositRequested(address indexed user,address indexed recipient,uint256 amount,bytes32 indexed mintRequestId)",
  "event WithdrawalRequested(bytes32 indexed withdrawalId,address indexed user,address indexed recipient,uint256 amount,bytes32 transferRequestId)",
  "event WithdrawalReleased(bytes32 indexed withdrawalId,address indexed recipient,uint256 amount)",
  "event BurnSubmitted(bytes32 indexed withdrawalId,uint256 amount,bytes32 burnRequestId)",
  "event BurnDebtRecorded(bytes32 indexed withdrawalId,uint256 amount,bytes reason)",
] as const;

export const POD_PORTAL_ADMIN_ABI = [
  "function setDepositFee(uint256 fixedFee, uint256 percentageBps, uint256 maxFee)",
  "function setWithdrawFee(uint256 fixedFee, uint256 percentageBps, uint256 maxFee)",
  "function getFeeConfig(bool isDeposit) view returns (uint256 fixedFee, uint256 percentageBps, uint256 maxFee)",
  "function accumulatedPortalFees() view returns (uint256)",
  "function estimateDepositFees(uint256 amount) view returns (uint256 portalFee,bool usedDynamicPricing,uint256 mintTotalFee,uint256 mintCallbackFee)",
  "function estimateWithdrawFees(uint256 amount) view returns (uint256 portalFee,bool usedDynamicPricing,uint256 transferTotalFee,uint256 transferCallbackFee)",
  "function pause()",
  "function unpause()",
  "function paused() view returns (bool)",
  "function setLimits(uint256 minDeposit, uint256 maxDeposit, uint256 minWithdraw, uint256 maxWithdraw)",
  "function minDepositAmount() view returns (uint256)",
  "function maxDepositAmount() view returns (uint256)",
  "function minWithdrawAmount() view returns (uint256)",
  "function maxWithdrawAmount() view returns (uint256)",
  "function setIsDepositEnabled(bool enabled)",
  "function isDepositEnabled() view returns (bool)",
  "function withdrawPortalFees(uint256 amount)",
  "function rescueNative(uint256 amount)",
  "function rescueERC20(address token, uint256 amount)",
] as const;

export const POD_PORTAL_FACTORY_ABI = [
  "function isAdmin(address account) view returns (bool)",
  "function isOperator(address account) view returns (bool)",
  "function DEFAULT_ADMIN_ROLE() view returns (bytes32)",
  "function OPERATOR_ROLE() view returns (bytes32)",
  "function hasRole(bytes32 role, address account) view returns (bool)",
  "function grantRole(bytes32 role, address account)",
  "function revokeRole(bytes32 role, address account)",
  "function feeRecipient() view returns (address)",
  "function rescueRecipient() view returns (address)",
  "event RoleGranted(bytes32 indexed role, address indexed account, address indexed sender)",
  "event RoleRevoked(bytes32 indexed role, address indexed account, address indexed sender)",
] as const;

export const POD_PTOKEN_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function nonces(address owner) view returns (uint256)",
  "function failedRequests(bytes32 requestId) view returns (bytes)",
  "function balanceOf(address account) view returns (tuple(uint256 ciphertextHigh,uint256 ciphertextLow))",
  "function balanceWithState(address account) view returns (tuple(uint256 ciphertextHigh,uint256 ciphertextLow) balance,bool pending,bool callbackErrored)",
  "function balanceOfWithStatus(address account) view returns (tuple(uint256 ciphertextHigh,uint256 ciphertextLow),bool)",
  "function transfer(address to, ((uint256,uint256),bytes) value, uint256 callbackFeeLocalWei) payable returns (bytes32)",
  "function estimateFee() view returns (uint256 totalFeeWei, uint256 targetFeeWei, uint256 callbackFeeWei)",
  "error TransferAlreadyPending(address from, address to, bytes32 requestId)",
  "event TransferRequestSubmitted(address indexed from,address indexed to,bytes32 requestId)",
  "event Transfer(address indexed from,address indexed to,bytes senderValue,bytes receiverValue)",
  "event TransferFailed(address indexed from,address indexed to,bytes errorMsg)",
  "event RequestCallbackFailed(address indexed from,address indexed to,bytes32 requestId,bytes callbackData)",
] as const;
